import CHW23Page from "components/pages/CHW23Page";

export default function CaptureCardsCardsMain(props) {
    return <CHW23Page />
}